var indentation_default = {
  "indentZero": "dMK5v",
  "indentOne": "t8D4u",
  "indentTwo": "wga5T",
  "indentThree": "tFRMY",
  "indentFour": "b69tz",
  "indentFive": "TgVsB",
  "indentSix": "J7YnS"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
